<script lang="ts">
    import type {LoanReminder} from 'src/typings';
    import {Kind} from 'shared/constants';
    import {getDateFormatter, getLocalization} from 'src/core';
    import type {PaginationData} from '../../search-manager/pagination';
    import KpSearchResultGenericTable from '../KpSearchResultGenericTable.svelte';
    import {fade} from 'svelte/transition';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import Label from 'shared/components/kp-label/Label.svelte';

    export let loanRemindersPaginationData: PaginationData<LoanReminder>;

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();

</script>

<KpSearchResultGenericTable>
    <tr slot="header">
        <th class="header-reminder-type">{localize(/* @kp-localization loan.reminder.ReminderType */ 'loan.reminder.ReminderType')}</th>
        <th class="header-reader">{localize(/* @kp-localization user.Reader */ 'user.Reader')}</th>
        <th class="header-document">{localize(/* @kp-localization commons.Record */ 'commons.Record')}</th>
        <th class="header-exemplar">{localize(/* @kp-localization commons.Exemplar */ 'commons.Exemplar')}</th>
        <th class="header-loan-info">{localize(/* @kp-localization loan.Loan */ 'loan.Loan')}</th>
        <th class="header-loan-reminder-info">{localize(/* @kp-localization commons.datum */ 'commons.datum')}</th>
        <th class="header-department">{localize(/* @kp-localization commons.Department */ 'commons.Department')}</th>
    </tr>

    <svelte:fragment slot="body">
        {#each loanRemindersPaginationData.items as loanReminder(loanReminder.id)}
            <tr in:fade>
                <td class="data-reminder-type">
                    {pipe(loanReminder.type, loc())}
                </td>

                <td class="data-reader">
                    <Label explicitKind={Kind.KIND_USER} labeled={loanReminder.loan.user}/>
                </td>

                <td class="data-document">
                    <Label explicitKind={Kind.KIND_RECORD} labeled={loanReminder.loan.document}/>
                </td>

                <td class="data-exemplar">
                    {#if loanReminder.loan.exemplar?.accessNumber}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization exemplar.AccessNumber.abbr */ 'exemplar.AccessNumber.abbr')}</small>
                            <small>{loanReminder.loan.exemplar.accessNumber}</small>
                        </div>
                    {/if}

                    {#if loanReminder.loan.exemplar?.barCode}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization exemplar.BarCode.abbr */ 'exemplar.BarCode.abbr')}</small>
                            <small>{loanReminder.loan.exemplar.barCode}</small>
                        </div>
                    {/if}

                    {#if loanReminder.loan.exemplar?.signature}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization exemplar.Signature.abbr */ 'exemplar.Signature.abbr')}</small>
                            <small>{loanReminder.loan.exemplar.signature}</small>
                        </div>
                    {/if}
                </td>

                <td class="data-loan-info">
                    {#if loanReminder.loan.loanCategory}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization loan.LoanCategoryAbbr */ 'loan.LoanCategoryAbbr')}</small>
                            <small>{pipe(loanReminder.loan.loanCategory, loc())}</small>
                        </div>
                    {/if}

                    {#if loanReminder.loan.lendDate}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization loan.LentFromAbbr */ 'loan.LentFromAbbr')}</small>
                            <small>{pipe(loanReminder.loan.lendDate, dateFormatter('d.M.yyyy'))}</small>
                        </div>
                    {/if}

                    {#if loanReminder.loan.dueDate}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization loan.LentToAbbr */ 'loan.LentToAbbr')}</small>
                            <small>{pipe(loanReminder.loan.dueDate, dateFormatter('d.M.yyyy'))}</small>
                        </div>
                    {/if}
                </td>

                <td class="data-loan-reminder-info">
                    {#if loanReminder.generationDate}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization loan.reminder.Generated */ 'loan.reminder.Generated')}</small>
                            <small>{pipe(loanReminder.generationDate, dateFormatter('d.M.yyyy'))}</small>
                        </div>
                    {/if}

                    {#if loanReminder.sentDate}
                        <div>
                            <small class="text-muted">{localize(/* @kp-localization loan.reminder.Sent */ 'loan.reminder.Sent')}</small>
                            <small>{pipe(loanReminder.sentDate, dateFormatter('d.M.yyyy'))}</small>
                        </div>
                    {/if}
                </td>

                <td class="data-department">{pipe(loanReminder.loan.department, loc())}</td>
            </tr>
        {/each}
    </svelte:fragment>
</KpSearchResultGenericTable>